import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBadgeState } from '@shared/models';
import * as Response from '@shared/models/showcase/showcase.response.type';
import { fetchBadgesByCategory, fetchLatestBadges,fetchBatchesByCategoryId } from '../queries';

const state: IBadgeState = {
    fetchingLatestBadges: false,
    latestBadges: [],
    fetchingBadgesByCategory: false,
    fetchingCategoryItemstBadges: false,
    badgesByCategory: [],
    badgesByCategoryItem: [],
};

const badgeSlice = createSlice({
    name: 'showcase-badge',
    initialState: state,
    reducers: {
        setLatestBadges: (state, { payload }: PayloadAction<Response.IFetchLatestBadgesResponseType>) => {
            state.latestBadges = payload;
        },
        setBadgesByCategory: (state, { payload }: PayloadAction<Response.IFetchBadgesByCategoryResponseType>) => {
            state.badgesByCategory = payload;
        },
        setBadgesByCategoryId: (state, { payload }: PayloadAction<Response.IBadgePerCategory[]>) => {
            state.badgesByCategoryItem = payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchLatestBadges.pending, (state) => {
            state.fetchingLatestBadges = true;
        });
        builder.addCase(fetchLatestBadges.rejected, (state) => {
            state.fetchingLatestBadges = false;
        });
        builder.addCase(fetchLatestBadges.fulfilled, (state) => {
            state.fetchingLatestBadges = false;
        });
        builder.addCase(fetchBadgesByCategory.pending, (state) => {
            state.fetchingBadgesByCategory = true;
        });
        builder.addCase(fetchBadgesByCategory.rejected, (state) => {
            state.fetchingBadgesByCategory = false;
        });
        builder.addCase(fetchBadgesByCategory.fulfilled, (state) => {
            state.fetchingBadgesByCategory = false;
        });
        builder.addCase(fetchBatchesByCategoryId.pending, (state) => {
            state.fetchingCategoryItemstBadges = true;
        });
        builder.addCase(fetchBatchesByCategoryId.rejected, (state) => {
            state.fetchingCategoryItemstBadges = false;
        });
        builder.addCase(fetchBatchesByCategoryId.fulfilled, (state) => {
            state.fetchingCategoryItemstBadges = false;
        });
    },
});

export const { setLatestBadges, setBadgesByCategory,setBadgesByCategoryId } = badgeSlice.actions;
export default badgeSlice.reducer;
